import { Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

export enum ListItemSize {
    SMALL = "small",
    MEDIUM = "medium",
    LARGE = "large",
}

export type SenecListItemProps = {
    size?: ListItemSize;
    overline?: string;
    title: string | ReactNode;
    left?: ReactNode;
    right?: ReactNode;
    onClick?: () => void;
};

export const SenecListItem = ({ left, right, title, overline, size = ListItemSize.MEDIUM, onClick }: SenecListItemProps) => {
    const isInteractive = onClick !== undefined;

    return (
        <Stack
            onClick={onClick}
            data-testid="senec-list-item"
            sx={{
                ...(size === ListItemSize.SMALL && {
                    padding: 1.8,
                    gap: 1,
                }),
                ...(size === ListItemSize.MEDIUM && {
                    padding: 2.5,
                    gap: 2.5,
                }),
                ...(size === ListItemSize.LARGE && {
                    padding: 3,
                    gap: {
                        xs: 3,
                        md: 5,
                    },
                }),
                flexDirection: "row",
                alignItems: "center",
                borderRadius: "12px",
                ...(isInteractive && {
                    "&:hover": {
                        backgroundColor: "neutralGray000.main",
                    },
                    "&:active": {
                        backgroundColor: "neutralGray05.main",
                    },
                    cursor: "pointer",
                }),
            }}
        >
            {left && <Stack>{left}</Stack>}

            <Stack flexGrow={2} gap={0.5}>
                {overline && (
                    <Typography variant="s1" color={"neutralGray60.main"}>
                        {overline}
                    </Typography>
                )}

                <Typography variant={size === ListItemSize.SMALL ? "body1" : "body1Medium"}>{title}</Typography>
            </Stack>

            {right && <Stack>{right}</Stack>}
        </Stack>
    );
};
